import { Login } from './login/Login.js';

class Onboarding {
  constructor(apiClient) {
    this.apiClient = apiClient;
    this.login = new Login(apiClient);
  }
  activate(provider, data) {
    return this.apiClient.post(`v1/onboarding/activate/${provider}`, data, {
      ...this.apiClient.withRequestContext()
    }).then(response => response.data);
  }
}

export { Onboarding };
//# sourceMappingURL=Onboarding.js.map
